var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m11.42 9.441 3.17 3.17c.264.264.41.615.41.989 0 .375-.146.725-.41.99-.264.264-.616.41-.99.41s-.726-.146-.99-.41l-3.169-3.17a5.554 5.554 0 0 1-2.841.78 5.563 5.563 0 0 1-3.96-1.64C1.583 9.501 1 8.095 1 6.6s.582-2.902 1.64-3.96C3.699 1.583 5.105 1 6.6 1s2.902.582 3.96 1.64A5.567 5.567 0 0 1 12.2 6.6a5.554 5.554 0 0 1-.78 2.841zM6.5 9.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6z",
  clipRule: "evenodd"
})));
export default SvgSearch;